import JwtService from "@/common/jwt.service";
import {API_URL} from "@/common/config";
import axios from "axios";
import qs from "qs";

axios.defaults.baseURL = API_URL;

const ApiService = {
    setHeader() {
        if (JwtService.getToken() !== "" && JwtService.getToken() !== null) {
            axios.defaults.headers.common[
                "Authorization"
                ] = `Bearer ${JwtService.getToken()}`;
        } else {
            delete axios.defaults.headers.common.Authorization
        }
    },

    async query(resource, params) {
        this.setHeader();

        return axios.get(resource, params).catch(error => {
            throw new Error(`ApiService ${error}`);
        });
    },
    
    get(resource, slug = "") {
        this.setHeader();
        
        return axios.get(`${resource}${slug}`)
    },
    
    getBlob(resource, slug = "") {
        this.setHeader();
        
        return axios.get(`${resource}${slug}/`, { responseType: "blob" })
    },

    get2(resource, slug = "") {
        this.setHeader();

        return axios.get(`${resource}${slug}`).catch(error => {
            throw new Error(`ApiService ${error}`);
        });
    },

    post(resource, params) {
        this.setHeader();

        return axios.post(`${resource}`, params);
    },

    postEncodedURI(resource, params) {
        return axios.post(`${resource}`, params, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            baseURL: ""
        });
    },

    postForm(resource, form) {
        this.setHeader();

        return axios.postForm(`${resource}`, form);
    },

    postEncoded(resource, form) {
        this.setHeader();

        return axios.post(`${resource}`, form, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        });
    },

    update(resource, slug, params) {
        this.setHeader();

        return axios.put(`${resource}/${slug}`, params);
    },

    put(resource, params) {
        this.setHeader();

        return axios.put(`${resource}`, params);
    },

    delete(resource) {
        this.setHeader();

        return axios.delete(resource);
    }
};
export const Budget = {
    async list(params) {
        return ApiService.query("/regions", {
            params: params,
            paramsSerializer: function (params) {
                return qs.stringify(params, {encode: false});
            }
        });
    },
    async account() {
        return ApiService.get(`/account`);
    },
    async accountSetActiveRole(roleId) {
        return ApiService.put(`/account/setActiveRole/${roleId}`);
    },
    async projectDraft(id) {
        return ApiService.get(`/project/budget/draft/${id}`);
    },
    async counterpartyById(id) {
        return ApiService.get(`/counterparty/detail/${id}`);
    }
}

export default ApiService;
